export const Status = { "Undefined": 0, "New": 1, "Started": 2, "Stopped" : 3};